exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colour-generator-heading h1[data-v-39e9cfac]{font-size:45px}", ""]);

// exports
